/* eslint-disable camelcase */
import { put, takeLatest } from 'redux-saga/effects';
import tracker from 'tracker';
import { useUser } from '@clerk/clerk-react';
import { userActions, login } from '../rootTypes';
import * as api from '../api';

export function* fetchUser() {
  try {
    const token = api.getToken();
    const { user } = useUser();
    if (user) {
      if (!localStorage.getItem('user_uuid')) {
        const current_user_request = yield api.userApi.get('/users/current', {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        const { id } = current_user_request.data.data;
        localStorage.setItem('user_uuid', id);
      }

      const uuid = localStorage.getItem('user_uuid');
      const userRequest = yield api.userApi.get(`/teachers/${uuid}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (userRequest.status !== 200) {
        throw new Error('User unauthorized');
      } else {
        tracker.trackEvent('Clicks - Successful Logins');
        yield put({
          type: userActions.fetchSuccess,
          payload: userRequest.data.data,
        });
      }
    } else {
      throw new Error('User unauthorized');
    }
  } catch (err) {
    yield put({ type: userActions.logout });
    yield put({
      type: login.failure,
      payload: { errors: [{ detail: 'user_invalid_scope' }] },
    });
  }
}

// eslint-disable-next-line import/prefer-default-export
export function* userSaga() {
  yield takeLatest(userActions.fetchRequest, fetchUser);
}
